// based on rc-trigger 2.6.5
import Trigger from './Trigger';
export default Trigger;
